module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/other-186.vue");


//////////////////
// WEBPACK FOOTER
// ./en/wechat/other.md
// module id = 627
// module chunks = 415